import { GameDefinition } from './types';

export const CARCASSONNE_GAME_ID = 'carcassonne';

export const carcassonneGameListing = {
  id: CARCASSONNE_GAME_ID,
  title: 'Carcassonne',
  subtitle: 'C3 + rozszerzenia C3.1 (2025)',
  icon: '🏰',
  players: '2–6 graczy',
  playTime: '35–120 min',
  contentStatus: 'ready' as const,
  logoAccessibilityLabel: 'Logo gry Carcassonne',
};

export const carcassonneGameDefinition: GameDefinition = {
  game: carcassonneGameListing,
  shortTitle: 'Carcassonne',
  author: 'Klaus-Jürgen Wrede · Hans im Glück',
  recommendedFirstGamePlayers: '2–4 graczy · baza + Rzeka + Opat',
  difficulty: 'łatwa do średniej (zależnie od dodatków)',
  instructionLanguage: 'polski',
  contentStatus: 'ready',
};

export const FIRST_GAME_RECOMMENDATION =
  'Na pierwszą partię włącz bazę, Rzekę i Opata. Po jednej partii możesz dodać Karczmy i Katedry.';

export const HAS_CARCASSONNE_LOGO = true;
